<template>
  <div class="controlList">
    <div class="item addItem">
      <router-link :to="{name: 'controlNewItem'}" class="spacetype">+</router-link>
    </div>
    <ControlListItem
      v-for="item in list"
      :key="`${item.spacetypeid}_${item.subtype}`"
      :locale="locale"
      :item="item"
      :isChkAll="isChkAll"
      @checkedItem="checkedItem" />
  </div>
</template>

<script>
import ControlListItem from '@/components/Control/ListItem.vue'

export default {
  props: [
    'locale',
    'list',
    'isChkAll'
  ],
  components: {
    ControlListItem
  },
  methods: {
    checkedItem (data) {
      this.$emit('checkedItem', data)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
